<template>
  <!-- popup (s) -->
  <div class="popWrap nowOpen">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">렌탈료 선납 후 가상스케줄</h1>
          </div>
          <div class="popBody">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <table class="tableX noLine rentalFee">
                  <caption>납입회차, 청구월, 청구금액에 대한 내용입니다.</caption>
                  <colgroup>
                    <col style="width:25%" />
                    <col style="width:30%" />
                    <col style="width:45%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>납입회차</th>
                      <th>청구월</th>
                      <th>청구금액(원)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(orderAuthSchedule, key) in orderAuthScheduleList" :key="key">
                      <td>{{ orderAuthSchedule.invoiceSeq | numberAddZero(2) }}</td>
                      <td>{{ orderAuthSchedule.demandMonth.substring(0, 4) }} - {{ orderAuthSchedule.demandMonth.substring(4, 6) }}</td>
                      <td class="ar">{{ orderAuthSchedule.demandAmount | currency }} 원</td>
                    </tr>
                  </tbody>
                </table>
                <div class="orderSum">
                  <ul class="infoList">
                    <li>
                      <span class="item pointC4">잔여 청구(예정)금액</span>
                      <span class="val">
                        <em>{{ totalDemandAmount | currency }}</em>
                        원
                      </span>
                    </li>
                  </ul>
                </div>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>
          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>
<script>
import ApiService from '@/common/api.service';

export default {
  name: 'RentalPrePayDiscountVirtualSchedulePop',
  props: ['propsVirtualScheduleObj'],
  data() {
    return {
      virtualScheduleObj: this.propsVirtualScheduleObj,
      orderAuthScheduleList: null,
      totalDemandAmount: 0,
    };
  },
  mounted() {
    // console.log(this.virtualScheduleObj);
    this.selectOrderAuthScheduleByOrderIdVirtualByPrePaidPeriod();
  },
  methods: {
    selectOrderAuthScheduleByOrderIdVirtualByPrePaidPeriod() {
      ApiService.service('GET', '/order/auth/schedule/' + this.virtualScheduleObj.orderId + '/virtual/' + this.virtualScheduleObj.prePaidPeriod)
        .then(({ data }) => {
          this.orderAuthScheduleList = data.result;
          // console.log(this.orderAuthScheduleList);

          for (let orderAuthSchedule of this.orderAuthScheduleList) {
            this.totalDemandAmount += orderAuthSchedule.demandAmount;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
  },
};
</script>
